import { inject } from '@angular/core';
import { HttpContextToken, HttpErrorResponse, HttpHandlerFn, HttpHeaders, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs';
import { OneTimeTokenService } from './one-time-token.service';

export const ONE_TIME_TOKEN_REQUIRED = new HttpContextToken<boolean>(() => false);

export const OneTimeTokenInterceptor: HttpInterceptorFn = (req, next) => {
	const tokenService = inject(OneTimeTokenService);
	const sendRequest = () => sendWithCurrentToken(req, next, tokenService);

	if (req.context.get(ONE_TIME_TOKEN_REQUIRED)) {
		return tokenService.serialize(sendRequest);
	}

	return sendRequest();
};

function sendWithCurrentToken(req: HttpRequest<unknown>, next: HttpHandlerFn, tokenService: OneTimeTokenService) {
	const token = tokenService.getToken();
	const guid = tokenService.getGuid();

	let modifiedReq = req;
	if (token && guid) {
		modifiedReq = req.clone({
			setHeaders: {
				'X-OTT-Token': token,
				'X-OTT-Guid': guid
			}
		});
	}

	return next(modifiedReq).pipe(
		tap({
			next: (event) => {
				if (event instanceof HttpResponse) {
					updateCredentials(event.headers, tokenService);
				}
			},
			error: (error: unknown) => {
				// The API consumes the token before calculating/validating the payload.
				// Save its replacement even on failure, before releasing the request queue.
				if (error instanceof HttpErrorResponse) {
					updateCredentials(error.headers, tokenService);
				}
			}
		})
	);
}

function updateCredentials(headers: HttpHeaders, tokenService: OneTimeTokenService): void {
	const token = headers.get('X-OTT-Token');
	const guid = headers.get('X-OTT-Guid');
	if (token) {
		tokenService.setToken(token);
	}
	if (guid) {
		tokenService.setGuid(guid);
	}
}
